﻿<script>
  import { onMount } from "svelte/internal";
  import { dispatchMountEvent, isValidFileType } from "./services";
  import Icon from "./Icons.svelte";
  import Papa from "papaparse";

  export let _emitMount;
  export let name;
  export let accept = ".csv";
  export let maxsize;
  export let onFileSelected;
  export let dataValid;
  export const clearInputElement = () => {
    if (fileInput) {
      fileInput.value = null;
      fileInput.dispatchEvent(new Event("change"));
    }
  };

  onMount(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  // local state
  let inputfiles = [];
  let previewFiles = [];
  let fileInput;
  let error = "";
  let openFileDialog = false;
  let successMessage = "";
  let loading = false;
  let fileContent = [];

  const removeSelectedFile = () => {
    if (openFileDialog) {
      // clear all
      previewFiles = [];
      successMessage = "";
      loading = false;
      fileContent = [];
    }
  };

  // remove input invalid state
  const removeInvalidState = () => {
    if (fileInput) {
      fileInput.classList.remove("is-invalid");
    }
  };

  // on error shown
  $: {
    if (error.length) {
      fileInput.value = "";
    }
  }
  // clear recenct attachment
  const ClearRecentAttachmentHandle = () => {
    inputfiles = [];
    previewFiles = [];
    fileInput.value = null;
    successMessage = "";
    loading = false;
    fileContent = [];
    fileInput.dispatchEvent(new Event("change"));
  };
  // set flag on dialog opoen
  const onDialogOpen = () => {
    openFileDialog = true;
  };

  // update previewFiles if fileInput valid
  $: {
    if (inputfiles && inputfiles.length) {
      previewFiles = inputfiles;
      // loading
      loading = true;
      successMessage = "";
      error = "";
      removeInvalidState();
    } else {
      removeSelectedFile();
    }
    openFileDialog = false;
  }

  // loading file content
  $: {
    if (previewFiles && previewFiles.length) {
      const file = previewFiles[0];
      // file extension
      if (!isValidFileType(file, accept)) {
        // error
        error = "File type not supported";
      }
      // file size
      else if (maxsize && file.size / 1024 / 1024 > maxsize) {
        // error
        error = "Maximum file size is " + maxsize + "mb";
      }

      if (!error.length) {
        loading = true;
        // parse
        Papa.parse(file, {
          error: (err, file) => {
            // display error message
            error = err;
            fileContent = [];
          },
          complete: (results, parser) => {
            // close loading
            if (!results.data || !results.data.length) {
              error = "File is empty!";
            } else {
              fileContent = results.data;
              successMessage = "File successfully loaded";
            }
          },
          skipEmptyLines: true
        });
      }
    }

    loading = false;
  }

  // emit event file content loaded
  $: {
    if (onFileSelected) {
      onFileSelected(fileContent);
    }
  }
</script>

<div class="rounded bg-light p-3">
  <div class="row half-gutters row-vertical-gutters align-items-center">
    <div class="col-auto">
      <label
        class="btn btn-primary btn-icon-start mb-0"
        for={name}
        on:click={onDialogOpen}>
        <Icon icon="Browse" class="icon icon-sm" />
        Upload .csv file
      </label>
    </div>
    <div class="col-auto mr-auto">
      <div class="font-italic text-muted">(max. upload {maxsize}mb)</div>
    </div>
    {#each previewFiles as file, i}
      <div class="col-auto">
        <a
          href="#"
          class="text-decoration-underline text-muted link-hover-danger medium
          btn-icon-start"
          on:click|preventDefault={ClearRecentAttachmentHandle}>
          <Icon icon="Trash" class="icon icon-sm" />
          Remove .csv file
        </a>
      </div>
    {/each}
  </div>
  <div>
    <input
      type="file"
      id={name}
      {name}
      class="form-control-hidden"
      bind:files={inputfiles}
      {accept}
      bind:this={fileInput}
      required />
  </div>
</div>
{#each previewFiles as file, i}
  <div class="pt-4" />
  <div class="uploader-file">
    <div class="uploader-file-content">
      <Icon icon="Csv" class="icon uploader-file-icon" />
      <h6 class="mb-0 mr-auto">{file.name}</h6>
    </div>
  </div>
{/each}

{#if error.length}
  <div class="pt-4" />
  <div class="alert alert-danger" role="alert">
    <div class="row no-gutters">
      <div class="col-auto">
        <Icon icon="XSolid" class="icon alert-icon" />
      </div>
      <div class="col">
        <h6 class="mb-0">{error}</h6>
      </div>
    </div>
  </div>
{/if}
{#if loading}
  <div class="pt-4" />
  <div class="progress">
    <div
      class="progress-bar progress-bar-striped progress-bar-animated
      bg-secondary"
      role="progressbar"
      aria-valuenow="100"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 100%" />
  </div>
{/if}
{#if successMessage.length && !error.length && dataValid}
  <div class="pt-4" />
  <div class="alert alert-success" role="alert">
    <div class="row no-gutters">
      <div class="col-auto">
        <Icon icon="CheckSolid" class="icon alert-icon" />
      </div>
      <div class="col">
        <h6 class="mb-0">{successMessage}</h6>
      </div>
    </div>
  </div>
{/if}
